// @flow

import React from 'react';
import type { ACFConfigChoice } from '../../types/acf';
import { configMapper } from './helpers';
import { withErrorEmptyComponent } from '../emptyComponent';

type Props = {
  component: ACFConfigChoice,
};

export default ({ component }: Props) => {
  const EmptyComponent = withErrorEmptyComponent(`Couldn't map ${component.acf_fc_layout} to a component in Config`);
  const Component = configMapper[component.acf_fc_layout] || EmptyComponent;

  return (
    <Component {...component} />
  );
};
